import { useState } from "react";
import {
    IconButton,
    Menu,
    MenuItem,
    ListItemText,
    Tooltip,
} from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";
import { useTranslation } from "react-i18next";

const languages = [
    { code: "pt-BR", label: "Português", flag: "🇧🇷" },
    { code: "en", label: "English", flag: "🇺🇸" },
    { code: "es", label: "Español", flag: "🇪🇸" },
] as const;

export default function LanguageSwitcher() {
    const { i18n, t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleChange = (code: string) => {
        i18n.changeLanguage(code);
        handleClose();
    };

    return (
        <>
            <Tooltip title={t("language.label")}>
                <IconButton
                    color="primary"
                    onClick={handleOpen}
                    sx={{ fontSize: "1.2rem" }}
                >
                    <LanguageIcon />
                </IconButton>
            </Tooltip>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }}
            >
                {languages.map((lang) => (
                    <MenuItem
                        key={lang.code}
                        onClick={() => handleChange(lang.code)}
                        selected={lang.code === i18n.language}
                    >
                        <ListItemText>
                            {lang.flag} {lang.label}
                        </ListItemText>
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}
